import { CheckIcon, XIcon } from '@phosphor-icons/react';

import { evaluatePasswordRules } from '@/features/auth';
import { palette } from '@/lib/design-tokens/primitives';

import styles from './password-checklist.module.scss';

type ChecklistRule = { id: string; label: string; test: (value: string) => boolean };

export function PasswordChecklist({
  value,
  rules: ruleSet,
}: {
  value: string;
  /** Overrides the forgot-password rules (Change Password has its own, US-117548 §D). */
  rules?: readonly ChecklistRule[];
}) {
  const rules = ruleSet
    ? ruleSet.map((rule) => ({ id: rule.id, label: rule.label, met: rule.test(value) }))
    : evaluatePasswordRules(value);
  return (
    <ul className={styles.list} aria-label="Password requirements">
      {rules.map((rule) => (
        <li
          key={rule.id}
          className={[styles.item, rule.met ? styles.met : ''].filter(Boolean).join(' ')}
          data-testid={rule.met ? 'rule-met' : 'rule-unmet'}
        >
          {rule.met ? (
            <CheckIcon size={16} fill={palette.success[900]} />
          ) : (
            <XIcon size={16} fill={palette.error[900]} />
          )}
          <span>{rule.label}</span>
        </li>
      ))}
    </ul>
  );
}
